import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';

export const templateXdrSearch = document.createElement('template');

templateXdrSearch.innerHTML = `
  <style>${commonStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
    <gz-push-body-layout>
      <div slot="push-body-sidenav-title">
          <gz-title id="smart-views-title" class="text-uppercase" fontWeight='600' fontSize='11'></gz-title>
      </div>

      <div slot="push-body-sidenav">
          <gz-grid-smart-views></gz-grid-smart-views>
      </div>

      <div class="wrapper" slot="push-body-content">
          <gz-xdr-search-query-panel class="search-query-panel"></gz-xdr-search-query-panel>
          <gz-xdr-search-results-panel></gz-xdr-search-results-panel>
          <gz-side-menu class="xdr-search-event-details-panel" resizable="left" menuwidth="400" closeOnClickOutside></gz-side-menu>
      </div>
     </gz-push-body-layout>
`;
